namespace TabAurous.Retail {
    export interface GiftVoucherAllocateDetailsForm {
        TransId: Serenity.IntegerEditor;
        GvMasterId: Serenity.IntegerEditor;
        GvNumber: Serenity.StringEditor;
        Value: Serenity.DecimalEditor;
        Amount: Serenity.DecimalEditor;
        CompanyId: Serenity.IntegerEditor;
        EmployeeId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
        RefVoucherTypeId: Serenity.IntegerEditor;
        RefTransId: Serenity.IntegerEditor;
        RefTransItemId: Serenity.IntegerEditor;
    }

    export class GiftVoucherAllocateDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.GiftVoucherAllocateDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!GiftVoucherAllocateDetailsForm.init)  {
                GiftVoucherAllocateDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(GiftVoucherAllocateDetailsForm, [
                    'TransId', w0,
                    'GvMasterId', w0,
                    'GvNumber', w1,
                    'Value', w2,
                    'Amount', w2,
                    'CompanyId', w0,
                    'EmployeeId', w0,
                    'UserId', w0,
                    'RefVoucherTypeId', w0,
                    'RefTransId', w0,
                    'RefTransItemId', w0
                ]);
            }
        }
    }
}
